import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const UserRoleSchema = withDefaults({
  type: 'user-role',
  fields: [
    {
      kind: 'attribute',
      name: 'roleType',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        // Must name the field on `user` that points back here -- that is
        // `userRoles` (a schema field). `roles` is only a getter in user.ext,
        // which the relationship graph cannot see, so the inverse resolved to
        // nothing and every /me load that sideloads a user-role blew up.
        inverse: 'userRoles',
      },
    },
    {
      kind: 'hasMany',
      name: 'relationships',
      type: 'user-relationship',
      options: {
        async: false,
        inverse: 'role',
      },
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default UserRoleSchema;
